"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _parseInt = require("@babel/runtime-corejs3/core-js-stable/parse-int");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = toInt;

function toInt(value) {
  var radix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  return _parseInt(value, radix);
}